import React, { Component } from "react"
import { connect } from "react-redux"
import cs from 'classnames'
import ClaimsWizard from "./Index"
import styles from './ClaimWizard.scss'
import i18n from 'lib/i18n'
import { getClaimMongoRecord } from "./claimsWizardService"

// variables out of module
const _ = i18n('claimWizard')

@connect(state => {
    const userAccess = state.app.security.actions
    let canCreateClaim = false
    userAccess.forEach((item, key) => {
        if (item.actionName == 'createclaim') {
            canCreateClaim = item.actionAllowed === "true" ? true : false
        }
    })

    return {
        canCreateClaim,
    }
})
export default class ClaimWizardButton extends Component {
    static propTypes = {
        contractNumber: React.PropTypes.string,
        claimNumber: React.PropTypes.string,
        contractId: React.PropTypes.string,
        contractNumber: React.PropTypes.string,
        clientId: React.PropTypes.string,
        onGoing: React.PropTypes.bool,
        isDigitalTable: React.PropTypes.bool,
        isClientContract: React.PropTypes.bool,
        onCloseMethod: React.PropTypes.func,
    }

    static defaultProps = {
        onGoing: false,
        isDigitalTable: false,
        isClientContract: false,
    }

    constructor(props) {
        super(props)
        this.state = {
            claimWizardIsOpened: false,
            claimData: {},
        }
    }

    async componentDidMount() {
        const { dispatch, contractId, claimNumber } = this.props

        const args = {}
        if (claimNumber) {
            args.claimNumber = claimNumber
        }
        if (contractId) {
            args.contractId = contractId
        }
    
        try {
            const claimData = await getClaimMongoRecord(dispatch, args)
    
            if (!claimData) {
                console.warn("No claim data found for the given arguments:", args)
                this.setState({ claimData: {} })
            } else {
                this.setState({ claimData })
            }
        } catch (error) {
            console.error("Error fetching claim data:", error)
            this.setState({ claimData: {} })
        }
    }

    onOpenClaimWizard = async () => {
        const { dispatch, contractId, claimNumber, isDigitalTable } = this.props
    
        const args = {}
        if (claimNumber) {
            args.claimNumber = claimNumber
        }
        if (contractId) {
            args.contractId = contractId
        }
    
        if (isDigitalTable) {
            const claimData = await getClaimMongoRecord(dispatch, args)
    
            if (!claimData) {
                console.warn("No claim data found for the given arguments:", args)
                this.setState({ claimData: {} })
            } else {
                this.setState({ claimData })
            }
        }

        this.setState({ claimWizardIsOpened: true })
    };

    onCloseClaimWizard = async () => {
        const { dispatch, contractId, claimNumber, isClientContract, onCloseMethod } = this.props

        if(isClientContract) {
            const args = {}
            if (claimNumber) {
                args.claimNumber = claimNumber
            }
            if (contractId) {
                args.contractId = contractId
            }

            const claimData = await getClaimMongoRecord(dispatch, args)

            if (!claimData) {
                console.warn("No claim data found for the given arguments:", args)
                this.setState({ claimData: {} })
            } else {
                this.setState({ claimData })
            }
        }

        this.setState({ claimWizardIsOpened: false })

        if (onCloseMethod) {
            onCloseMethod()
        }
    };

    getIcon = menuName => {
        try {
            return require(`resources/images/icn-${menuName}.svg`)
        } catch (err) {
            return require(`resources/images/icn-no-result.svg`)
        }
    }

    render() {

        const { canCreateClaim, contractId, claimNumber, clientId, brokerNumber, onGoing, isClientContract, contractNumber } = this.props
        const { claimWizardIsOpened, claimData } = this.state
        const disabled = false

        const claimStatus = claimData ? claimData.claimStatus : null;

        return (
            <div className={styles.claimWizardButtonContainer}>
                {canCreateClaim &&
                    <div
                        key={"claimWizardBtn"}
                        className={cs(styles.grayButtonFlex, styles.claimWizardButton, (disabled ? styles.disabled : ''))}
                        onClick={(e) => (!disabled ? this.onOpenClaimWizard(e) : e.preventDefault())}
                    >
                        <img className={cs(styles.claimWizardButtonIcon)} src={this.getIcon('claimWizard-white')} />
                        {claimData && claimStatus === '8' || onGoing ? _('continueClaimButton') : _('createClaimButton')}
                    </div>}
                {claimWizardIsOpened &&
                    <ClaimsWizard
                        contractId={contractId}
                        claimNumber={claimNumber}
                        contractNumber={contractNumber}
                        clientId={clientId}
                        brokerNumber={brokerNumber}
                        claimWizardIsOpened={claimWizardIsOpened}
                        closeWizard={() => this.onCloseClaimWizard()}
                        onGoing={onGoing}
                        isClientContract={isClientContract}
                    />
                }
            </div>

        )
    }
}


// WEBPACK FOOTER //
// ./components/ClaimsWizard/ClaimWizardButton.jsx